import { Controller } from "@hotwired/stimulus"

// Modal for finding chefs to follow. Opens, shows a scrollable list
// of users (recent non-followed by default), filters as you type.
export default class extends Controller {
  static targets = ["overlay", "input", "frame"]
  static values = { url: String }

  open() {
    this.overlayTarget.classList.remove("hidden")
    document.body.style.overflow = "hidden"
    requestAnimationFrame(() => this.inputTarget?.focus())
  }

  close() {
    this.overlayTarget.classList.add("hidden")
    document.body.style.overflow = ""
  }

  backdropClose(event) {
    if (event.target === event.currentTarget) this.close()
  }

  search() {
    clearTimeout(this._timer)
    const q = this.inputTarget.value.trim()
    this._timer = setTimeout(() => {
      const url = new URL(this.urlValue, window.location.origin)
      if (q) url.searchParams.set("q", q)
      this.frameTarget.src = url.toString()
    }, 200)
  }
}
